module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/ear-4912af5f8fedbf73fcd489dde8acd084.svg";